export type PostSignInRouteInput = {
  invitationsCount: number;
  defaultCompanyId: number | null;
};

export const getPostSignInRoute = ({
  invitationsCount,
  defaultCompanyId,
}: PostSignInRouteInput): string => {
  if (invitationsCount > 0) {
    return "/invitations";
  }

  if (!defaultCompanyId || defaultCompanyId === 0) {
    return "/create-company";
  }

  return "/scheduling";
};
